import { useState } from "react";
import Text from "../../../../components/Common/Text";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import CustomTable from "../../../../components/CustomTable/CustomTable";
import Pagination from "../../../../components/CustomTable/Pagination";
import CustomSeparator from "../../../../components/Common/CustomSeparator";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import CustomSearchableSelect from "../../../../components/CustomForm/CustomSearchableSelect";
import CustomSelect from "../../../../components/CustomForm/CustomSelect";
import CustomCheckbox from "../../../../components/CustomForm/CustomCheckbox";
import CustomIconInput from "../../../../components/CustomForm/CustomIconInput";
import { Form, FormGroup } from "../../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../../hooks/useEmpresa";
import CheckRender from "../../../../components/Common/CheckRender";
import usePermissions from "../../../../hooks/usePermissions";
import PropTypes from "prop-types";
import { standVirtualHabilitadoOptions } from "../../../../utils/LocalData";
import Colors from "../../../../themes/Colors";
import Tooltip from "../../../../components/Common/Tooltip";
import CustomIcon from "../../../../components/Common/CustomIcon";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";

const ConfiguracionStandVirtualBusquedaDetalle = (props) => {
  const {
    prestador,
    procedimientos,
    procedimientoSeleccionado,
    coberturas,
    paginacion,
    filtroCobertura,
    tieneModificacionesPendientes,
    onChangeProcedimientoSeleccionado,
    onChangeCoberturaSelectionChanged,
    onChangeSelecionarTodosCoberturas,
    onGuardarCoberturas,
    onPageChange,
    onPrestadorStandVirtualChange,
    onFiltroCoberturaChange,
    onFiltrarPorCobertura
  } = props;
  const empresa = useEmpresa();
  const { canEditStandVirtualConfig, isMonitor } = usePermissions();
  const [seleccionarTodos, setSeleccionarTodos] = useState(false);

  const columnas = () => {
    return [
      {
        title: "Procedimiento",
        dataIndex: "procedimiento",
        key: "procedimiento",
        width: "80%"
      },
      {
        title: "Código",
        dataIndex: "cobertura",
        key: `cobertura-${Math.random()}`,
        width: "20%"
      },
      {
        title: "Acción",
        dataIndex: "cobertura",
        key: "cobertura",
        width: "20%",
        renderHeader: () => {
          return (
            <CustomCheckbox
              checked={seleccionarTodos}
              checkedColor={empresa?.COLOR_SECUNDARIO}
              uncheckedColor={Colors.blueTransparent}
              checkmarkColor={Colors.white}
              onChange={(checked) => {
                const isChecked =
                  typeof checked === "boolean"
                    ? checked
                    : !!(
                        checked?.target?.checked ??
                        checked?.value?.target?.checked
                      );
                setSeleccionarTodos(isChecked);
                onChangeSelecionarTodosCoberturas(isChecked);
              }}
              disabled={isMonitor}
            />
          );
        },
        render: (text, record) => {
          return (
            <CustomCheckbox
              checked={record.configurado === 1 ? true : false}
              checkedColor={empresa?.COLOR_PRINCIPAL}
              uncheckedColor={Colors.blueTransparent}
              checkmarkColor={Colors.white}
              onChange={(checked) => {
                const isChecked =
                  typeof checked === "boolean"
                    ? checked
                    : !!(
                        checked?.target?.checked ??
                        checked?.value?.target?.checked
                      );
                onChangeCoberturaSelectionChanged({
                  ...record,
                  configurado: isChecked ? 1 : 0
                });
              }}
              disabled={isMonitor}
            />
          );
        }
      }
    ];
  };

  const handleBuscarCoberturas = (e = null) => {
    e?.preventDefault();
    onFiltrarPorCobertura();
  };

  const onClean = () => {
    if (filtroCobertura === "") return;
    onFiltroCoberturaChange("");
    onFiltrarPorCobertura(true);
  };

  return (
    <>
      <Section>
        <Text size="22px" color={empresa?.COLOR_PRINCIPAL} weight={"bold"}>
          {`${prestador.nombrePss} (${prestador.codigoPss})`}
        </Text>
      </Section>
      <Section justify={"flex-start"} gap={"20px"}>
        <FormGroup width={"60%"}>
          <CustomSearchableSelect
            label={"Tipo de Procedimiento"}
            placeholder={"Buscar por código o descripción..."}
            isLabelWithContainer={true}
            labelWidth={"100%"}
            value={procedimientoSeleccionado?.codigoTipoCobertura}
            onChange={(value) => {
              onChangeProcedimientoSeleccionado(
                procedimientos.find(
                  (item) => item.codigoTipoCobertura === Number(value)
                )
              );
            }}
            options={
              procedimientos.map((item) => ({
                value: item.codigoTipoCobertura,
                label: `${item.descripcionTipoCobertura} (${item.codigoTipoCobertura})`
              })) || []
            }
          />
        </FormGroup>

        <FormGroup width={"40%"}>
          <CustomSelect
            label={"Habilitar Stand Virtual al PSS"}
            isLabelWithContainer={true}
            labelWidth={"100%"}
            value={prestador.standVirtualHabilitado ? "1" : "0"}
            onChange={(value) => {
              onPrestadorStandVirtualChange &&
                onPrestadorStandVirtualChange(value === "1");
            }}
            options={standVirtualHabilitadoOptions}
            disabled={isMonitor}
          />
        </FormGroup>
      </Section>

      <Section justify={"flex-start"}>
        <CheckRender allowed={procedimientoSeleccionado}>
          <Form onSubmit={handleBuscarCoberturas}>
            <FormGroup width={"100%"}>
              <CustomIconInput
                type={"text"}
                placeholder={
                  "Buscar por código o descripción del procedimiento"
                }
                width={"360px"}
                value={filtroCobertura}
                onChange={(e) => onFiltroCoberturaChange(e)}
                icons={
                  <>
                    <Tooltip text="Buscar">
                      <CustomIcon
                        icon={SearchOutlined}
                        style={{
                          color: empresa?.COLOR_PRINCIPAL,
                          fontSize: 30
                        }}
                        hoverColor={empresa?.COLOR_SECUNDARIO}
                        onClick={handleBuscarCoberturas}
                      />
                    </Tooltip>
                    <Tooltip text="Limpiar">
                      <CustomIcon
                        icon={DeleteOutlined}
                        style={{
                          color: empresa?.COLOR_PRINCIPAL,
                          fontSize: 30
                        }}
                        hoverColor={empresa?.COLOR_SECUNDARIO}
                        onClick={onClean}
                      />
                    </Tooltip>
                  </>
                }
              />
            </FormGroup>
          </Form>
        </CheckRender>
      </Section>

      <Section
        style={{
          padding: "0px",
          flexDirection: "column",
          gap: "10px",
          alignItems: "center"
        }}
      >
        <CheckRender allowed={coberturas?.length > 0}>
          <CustomTable
            columns={columnas()}
            dataSource={coberturas}
            showPagination={false}
            pageSize={paginacion?.tamanoPagina || 20}
            width={"100%"}
          />
          <Pagination
            currentPage={paginacion?.numeroPagina || 1}
            itemsPerPage={paginacion?.tamanoPagina || 20}
            totalItems={paginacion?.totalRegistros || 0}
            onPageChange={onPageChange}
          />
        </CheckRender>
      </Section>
      <CustomSeparator height={"20px"} />
      <CheckRender allowed={coberturas.length > 0 && canEditStandVirtualConfig}>
        <Section justify={"center"} marginTop={"20px"}>
          <CustomButton
            label={"Guardar"}
            width={"200px"}
            onClick={onGuardarCoberturas}
            disabled={!tieneModificacionesPendientes}
          />
        </Section>
      </CheckRender>
      <CheckRender allowed={coberturas.length > 0 && isMonitor}>
        <Text size="14px" color="#999" textAlign="center" margin="10px 0">
          Solo tienes permisos de visualización. No puedes guardar cambios.
        </Text>
      </CheckRender>
    </>
  );
};

ConfiguracionStandVirtualBusquedaDetalle.propTypes = {
  prestador: PropTypes.shape({
    nombrePss: PropTypes.string,
    codigoPss: PropTypes.number
  }).isRequired,
  procedimientos: PropTypes.arrayOf(
    PropTypes.shape({
      codigoTipoCobertura: PropTypes.number,
      tipoProcedimiento: PropTypes.string
    })
  ).isRequired,
  procedimientoSeleccionado: PropTypes.shape({
    codigoTipoCobertura: PropTypes.number,
    tipoProcedimiento: PropTypes.string
  }),
  coberturas: PropTypes.arrayOf(
    PropTypes.shape({
      procedimiento: PropTypes.string.isRequired,
      cobertura: PropTypes.number.isRequired,
      configurado: PropTypes.number.isRequired
    })
  ).isRequired,
  paginacion: PropTypes.shape({
    numeroPagina: PropTypes.number,
    tamanoPagina: PropTypes.number,
    totalPaginas: PropTypes.number,
    totalRegistros: PropTypes.number
  }),
  onChangeProcedimientoSeleccionado: PropTypes.func.isRequired,
  onChangeCoberturaSelectionChanged: PropTypes.func.isRequired,
  onChangeSelecionarTodosCoberturas: PropTypes.func.isRequired,
  onGuardarCoberturas: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired
};

export default ConfiguracionStandVirtualBusquedaDetalle;
